var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen || _vm.makeHtmlReady
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "modal is-active",
        },
        [
          _c("div", {
            staticClass: "modal-background",
            on: { click: _vm.hideModal },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-card" },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c(
                  "p",
                  { staticClass: "modal-card-title" },
                  [_vm._t("title")],
                  2
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "delete",
                  attrs: { "aria-label": "close", type: "button" },
                  on: { click: _vm.hideModal },
                }),
              ]),
              _vm._v(" "),
              _vm._t("under-header"),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "modal-card-body",
                  class: { "is-paddingless": _vm.hideBodyPadding },
                },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _vm._t("footer"),
                    _vm._v(" "),
                    _c(
                      "a",
                      { staticClass: "button", on: { click: _vm.hideModal } },
                      [_vm._v(_vm._s(_vm.$t("forms.modal.close")))]
                    ),
                  ],
                  2
                ),
              ]),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }